@if (certificate){
<div class="certificate-alignment">
  <div [ngClass]="isPdf ? 'certificate-pdf-wrapper' : 'certificate-wrapper'" [style.backgroundImage]="backgroundImageUrl">
    <div [ngClass]="{
      'certificate-body': true,
      'certificate-body-quant': certificate?.event?.subtype === 'Quant Accelerator'
    }">
      <div class="certificate-user-name-wrapper">
        <span class="certificate-user-name"
          >{{ certificate.user.firstName }}
          {{ certificate.user.lastName }}</span
        >
      </div>
      <span class="certificate-desc">{{ description }}</span>
      <span class="certificate-date">{{
        certificate.event.date | date : "MMMM yyyy"
      }}</span>
    </div>
  </div>
</div>
}
